import apiClient from './apiClient';

// ============================================================
// Types -- matching backend Go models (pw2202/models/pw2202.go)
// ============================================================

export interface F2120 {
  f2120_01: string;          // 退回單號 (PK)
  f2120_07: string;          // 庫號
  f2120_11: string | null;   // 日期
  f2120_12: string;          // 人員代號
  f2120_13: string;          // 公司代號(廠商)
  f2120_14: string;          // 發票號碼
  f2120_15: string;          // 單據說明
  f2120_16: number;          // 明細筆數
  f2120_17: number;          // 明細金額合計
  f2120_18: number;          // 含稅別(1=含稅,2=免稅)
  f2120_19: number;          // 稅額
  f2120_20: number;          // 含稅總金額
  f2120_21: number;          // 已收金額
  f2120_23: number;          // 交通費
  f2120_24: number;
  f2120_25: number;          // 運費
  f2120_26: number;
  f2120_28: number;          // 未稅總金額
  f2120_30: string;          // 備註
  f2120_31: string;          // 跳號別
  f2120_33: string;
  f2120_34: string | null;
  f2120_80: string;          // 核准狀態 N/P
  f2120_81: string;          // 核准人
  f2120_82: string | null;   // 核准日期
  f2120_90: number;
  f2120_91: string;          // 建檔人員
  f2120_92: string | null;   // 建檔日期
  f2120_93: string;

  details?: F2121[];
}

export interface F2121 {
  f2121_01: string;          // 退回單號 (FK)
  f2121_02: number;          // 項次
  f2121_03: string;
  f2121_04: string | null;
  f2121_07: string;          // 庫號
  f2121_11: string;          // 產品代號
  f2121_11a: string;         // 產品名稱
  f2121_12: string;          // 單位
  f2121_13: number;          // 數量
  f2121_14: number;          // 單價
  f2121_15: number;          // 金額
  f2121_16: number;
  f2121_17: number;
  f2121_18: string;          // 摘要
  f2121_19: number;
  f2121_21: string;          // 訂單編號
  f2121_22: number;          // 訂單序號
  f2121_90: number;
  f2121_91: string;
  f2121_92: string | null;
  f2121_93: string;
}

// ============================================================
// Request / Response types
// ============================================================

export interface PW2202ListResponse {
  data: F2120[];
  total: number;
  page: number;
  size: number;
}

export interface PW2202CreateRequest {
  master: Partial<F2120>;
  details: Partial<F2121>[];
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const pw2202Api = {
  async list(page = 1, size = 20): Promise<PW2202ListResponse> {
    const res = await apiClient.get('/api/pw2202', { params: { page, size } });
    return res.data;
  },

  async get(id: string): Promise<F2120> {
    const res = await apiClient.get(`/api/pw2202/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: PW2202CreateRequest): Promise<F2120> {
    const res = await apiClient.post('/api/pw2202', data);
    return res.data;
  },

  async update(id: string, data: PW2202CreateRequest): Promise<F2120> {
    const res = await apiClient.put(`/api/pw2202/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/pw2202/${encodeURIComponent(id)}`);
  },

  /** Lookup: get display name for a reference table code */
  async lookupName(type: string, code: string): Promise<string> {
    if (!code || !code.trim()) return '';
    try {
      const res = await apiClient.get(`/api/pw2202/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch {
      return '';
    }
  },

  /** Get product info (name + unit + price) for detail row auto-fill */
  async getProductInfo(code: string): Promise<{ name: string; unit: string; price: number } | null> {
    if (!code || !code.trim()) return null;
    try {
      const res = await apiClient.get('/api/lookup/product-info', { params: { code: code.trim() } });
      return res.data || null;
    } catch {
      return null;
    }
  },
};
